import { Controller } from "@hotwired/stimulus";

// Generic "fetch a fragment and show it in a modal" trigger, replacing the
// old jQuery fancybox `popup_ajax`/`popup_ajax_do` helpers for pages
// rebuilt in Tailwind. Usage: a trigger element with
// data-controller="ajax-modal" data-ajax-modal-url-value="/some/path"
// data-action="click->ajax-modal#open", containing a
// data-ajax-modal-target="modal" (hidden overlay) with a
// data-ajax-modal-target="body" element inside it to receive the response.
export default class extends Controller {
  static targets = ["modal", "body"];
  static values = { url: String };

  open(event) {
    event.preventDefault();
    this.modalTarget.classList.remove("hidden");
    if (this.bodyTarget.dataset.loaded === "true") return;

    this.bodyTarget.innerHTML = '<div class="p-8 text-center text-sm text-gray-500">Laddar...</div>';
    fetch(this.urlValue)
      .then((response) => response.text())
      .then((html) => {
        this.bodyTarget.innerHTML = html;
        this.bodyTarget.dataset.loaded = "true";
      })
      .catch(() => {
        this.bodyTarget.innerHTML = '<div class="p-8 text-center text-sm text-gray-500">Något gick fel.</div>';
      });
  }

  close() {
    this.modalTarget.classList.add("hidden");
  }

  // Wired via data-action="click->ajax-modal#closeOnBackdrop" on the same
  // element as data-ajax-modal-target="modal" (which doubles as the
  // backdrop). event.currentTarget is always that backdrop element;
  // event.target is whatever was actually clicked -- equal only when the
  // click landed on the backdrop itself, not a bubbled click from the
  // card/content inside it.
  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.close();
  }
}
